"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgoraAttendeeTile = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AttendeeDisabledCamera = _interopRequireDefault(require("./AttendeeDisabledCamera"));
var _logger = require("@studio/logger");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LOG = new _logger.StudioLogger('agora-attendee-tile');
var THUMB_WIDTH = 200;
var THUMB_HEIGHT = 112;
var THUMB_CREATION_TIMEOUT = 3000;
/**
 * Component that renders video tiles for attendees in an Agora video call.
 * Uses direct track.play() method instead of specialized track components.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string} props.attendeeId - Unique identifier for the attendee
 * @param {Object} props.attendeeTiles - Object mapping attendee IDs to their video tracks
 * @param {boolean} [props.isCameraOn=true] - Whether the attendee's camera is enabled
 * @param {boolean} props.isLocalAttendee - Whether this tile represents the local user
 * @param {function} [props.onThumbnailReady] - Callback function to receive thumbnail data URL
 * @returns {JSX.Element} The rendered video tile component
 */
var AgoraAttendeeTile = exports.AgoraAttendeeTile = function AgoraAttendeeTile(_ref) {
  var _videoTrack$_config;
  var attendeeId = _ref.attendeeId,
    attendeeTiles = _ref.attendeeTiles,
    _ref$isCameraOn = _ref.isCameraOn,
    isCameraOn = _ref$isCameraOn === void 0 ? true : _ref$isCameraOn,
    isLocalAttendee = _ref.isLocalAttendee,
    onThumbnailReady = _ref.onThumbnailReady;
  var videoContainerRef = (0, _react.useRef)(null);
  var thumbnailCreatedRef = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVideoLoaded = _useState2[0],
    setIsVideoLoaded = _useState2[1];
  var videoTrack = attendeeTiles[attendeeId];
  var cameraId = videoTrack === null || videoTrack === void 0 || (_videoTrack$_config = videoTrack._config) === null || _videoTrack$_config === void 0 ? void 0 : _videoTrack$_config.cameraId;
  var userBackground = videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.userBackground;
  var isScreenShare = attendeeId.includes('#content');
  (0, _react.useEffect)(function () {
    var createThumbnail = function createThumbnail() {
      if (!isScreenShare) return;
      if (!videoTrack || !videoContainerRef.current || !onThumbnailReady) {
        LOG.warn('Cannot generate thumbnail: missing video track or canvas or callback');
        return;
      }
      try {
        var videoElement = videoContainerRef.current;
        if (!videoElement) {
          LOG.warn('Cannot generate thumbnail: video element not found');
          return;
        }
        if (thumbnailCreatedRef.current) return;
        var canvas = document.createElement('canvas');
        canvas.width = THUMB_WIDTH;
        canvas.height = THUMB_HEIGHT;
        canvas.getContext('2d').drawImage(videoElement, 0, 0, THUMB_WIDTH, THUMB_HEIGHT);
        onThumbnailReady(canvas.toDataURL('image/png'));
        thumbnailCreatedRef.current = true;
      } catch (error) {
        LOG.error('Error generating thumbnail:', error);
      }
    };
    var timerId = setTimeout(createThumbnail, THUMB_CREATION_TIMEOUT);
    return function () {
      clearTimeout(timerId);
    };
  }, [videoTrack, onThumbnailReady]);
  (0, _react.useEffect)(function () {
    var videoElement = videoContainerRef.current;
    var startVideo = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var mediaStreamTrack;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(isCameraOn && videoTrack && videoContainerRef.current)) {
                _context.next = 14;
                break;
              }
              LOG.info('Starting video for', attendeeId);
              _context.prev = 2;
              if (videoTrack.transformedVideoTrack) {
                mediaStreamTrack = videoTrack.transformedVideoTrack.getMediaStreamTrack();
              } else {
                mediaStreamTrack = videoTrack.getMediaStreamTrack();
              }
              videoElement.srcObject = new MediaStream([mediaStreamTrack]);
              _context.next = 7;
              return videoElement.play();
            case 7:
              setIsVideoLoaded(true);
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              LOG.error('Error playing video track:', _context.t0);
              setIsVideoLoaded(false);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10]]);
      }));
      return function startVideo() {
        return _ref2.apply(this, arguments);
      };
    }();
    startVideo();
    return function () {
      if (videoTrack && videoElement) {
        videoTrack.stop();
        videoElement.srcObject = null;
        setIsVideoLoaded(false);
      }
    };
  }, [videoTrack, isCameraOn, cameraId, userBackground]);
  if (!isCameraOn) return /*#__PURE__*/_react["default"].createElement(_AttendeeDisabledCamera["default"], null);
  return /*#__PURE__*/_react["default"].createElement("video", {
    ref: videoContainerRef,
    "data-testid": "video-tile-".concat(attendeeId),
    id: "video-tile-".concat(attendeeId),
    className: "video-container ".concat(isLocalAttendee ? 'local-video' : 'remote-video'),
    style: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: isVideoLoaded || isScreenShare ? 'transparent' : 'black',
      objectFit: isScreenShare ? 'contain' : 'cover',
      transform: isLocalAttendee ? 'scaleX(-1)' : 'none'
    }
  });
};
AgoraAttendeeTile.propTypes = {
  attendeeId: _propTypes["default"].string.isRequired,
  attendeeTiles: _propTypes["default"].object.isRequired,
  isCameraOn: _propTypes["default"].bool,
  isLocalAttendee: _propTypes["default"].bool.isRequired,
  onThumbnailReady: _propTypes["default"].func
};